<template>
  <div class="workout-item">
    <router-link :to="{ name: 'exercise-detail', params:{id:$root.getLink(exerciseItem)}}" class="workout-item-link" v-if="!!exerciseItem.media.general">
      <div class="workout-item-image">
        <img :src="exerciseItem.media.general[0].image" alt="">
      </div>
      <div class="workout-item-top">
        <div class="d-flex justify-content-between align-items-center">
          <div class="workout-item-flag-wrapper">
            <div class="workout-item-flag d-flex justify-content-center align-items-center" v-if="!!exerciseItem.is_premium && exerciseItem.is_premium === '1'">
              <div class="workout-item-flag-icon d-flex justify-content-center align-items-center d-lg-inline-block">
                <lock2/>
              </div>
              <p class="d-none d-lg-block">PREMIUM</p>
            </div>
          </div>
          <button type="button" class="workout-item-bookmark" :class="[ exerciseItem.bookmarked ? 'active' : '']" v-on="exerciseItem.bookmarked == true ? { click: removeBookmark } : { click: addBookmark }">
            <bookmark/>
          </button>
        </div>
      </div>
      <div class="workout-item-content">
        <p class="workout-item-title">{{ exerciseItem.title }}</p>
        <div class="workout-item-tags">
          <div v-if="exerciseItem.duration" class="workout-item-tag-item d-flex justify-content-center align-items-center">
            <div class="workout-item-tag-item-icon d-none d-lg-flex justify-content-center align-items-center">
              <clock/>
            </div>
            <p>{{ exerciseItem.duration }}</p>
          </div>
          <div v-if="exerciseItem.level" class="workout-item-tag-item d-flex justify-content-center align-items-center">
            <div class="workout-item-tag-item-icon d-none d-lg-flex justify-content-center align-items-center">
              <fire/>
            </div>
            <p>{{ exerciseItem.level }}</p>
          </div>
        </div>
      </div>
    </router-link>
  </div>
</template>

<script>
import bookmark from "@/components/svg/bookmark.vue";
import lock2 from "@/components/svg/lock2.vue";
import clock from "@/components/svg/clock.vue";
import level from "@/components/svg/level.vue";
import fire from "@/components/svg/fire.vue";
import axios from "axios";
import qs from "qs";

export default {
  name: "exercise-item",
  data() {
    return {
      errors: [],
      showMessage: false,
      formResponseMessage: '',
    }
  },
  components : {
    bookmark,
    lock2,
    clock,
    level,
    fire
  },
  props: {
    exerciseItem: {
      required: true,
    },
  },
  methods: {
    addBookmark(e) {
      e.preventDefault();

      let authKey = window.$cookies.get("authKey");

      const requestBody = {
        related_id: this.exerciseItem.id,
        related_type: 0,
      };

      axios
          .post(process.env.VUE_APP_API_URL + 'bookmark', qs.stringify(requestBody),{
            headers: {
              Authorization: 'Bearer ' + authKey
            }
          })
          .then((response) => {
            if (response.data.success) {
              this.exerciseItem.bookmarked = true;

              let bookmark = {
                "id": this.exerciseItem.id,
                "title": this.exerciseItem.title,
                "level": this.exerciseItem.level,
                "duration": this.exerciseItem.duration,
                "slug": this.exerciseItem.slug
              };

              this.$root.workoutBookmarks.push(bookmark);
            }
          })
          .catch((e) => {
            this.errors.push(e);
            this.showMessage = true;
            this.formResponseMessage = 'An error occurred.';
          });
    },
    removeBookmark(e) {
      e.preventDefault();

      let authKey = window.$cookies.get("authKey");

      const requestBody = {
        bookmark: this.exerciseItem.id,
      };

      axios
          .post(process.env.VUE_APP_API_URL + 'bookmark', qs.stringify(requestBody),{
            headers: {
              Authorization: 'Bearer ' + authKey
            }
          })
          .then((response) => {
            if (response.data.success) {
              this.exerciseItem.bookmarked = false;
            }
          })
          .catch((e) => {
            this.errors.push(e);
            this.showMessage = true;
            this.formResponseMessage = 'An error occurred.';
          });
    },
  },
}
</script>